module.exports = __webpack_public_path__ + "img/nextPage.598eaee5.svg";